export default __webpack_public_path__ + "static/media/sample-product.10840a7c.jpg";